import React, { createContext, useState, useEffect } from 'react';

const GlobalUiContext = createContext();

const GlobalUiContextProvider = ({ children }) => {
  const [hamburgerOpened, setHamburgerOpened] = useState(false);
  const [searchOpened, setSearchOpened] = useState(false);

  useEffect(() => {
    if (searchOpened) {
      document.querySelector('body').classList.add('overflow-hidden');
      return;
    }

    document.querySelector('body').classList.remove('overflow-hidden');
  }, [searchOpened]);

  return (
    <GlobalUiContext.Provider value={{
      hamburgerOpened,
      searchOpened,
      toggleHamburger: () => setHamburgerOpened(!hamburgerOpened),
      toggleSearch: () => setSearchOpened(!searchOpened),
      disableSearch: () => setSearchOpened(false),
      enableSearch: () => setSearchOpened(true)
    }}
    >
      {children}
    </GlobalUiContext.Provider>
  );
};

const GlobalUiContextConsumer = GlobalUiContext.Consumer;

export { GlobalUiContextProvider, GlobalUiContextConsumer, GlobalUiContext };
